export class LoginError extends Error {
    constructor(message) {
        super(message); // (1)

        // Set the prototype explicitly.
        Object.setPrototypeOf(this, LoginError.prototype);
    }
}
